<template>
  <div class="caraddstorelist">
    <m-title :titlelist="listitem"></m-title>
    <div class="carlist-box">
      <div class="box-title">
        <div class="carlist-box-title">
          <div class="title-left"></div>
          <div class="title-right">充电站列表</div>
        </div>
        <div class="carinfo">
          <div class="info-left">
            <div class="carplate">
              <div class="name">充电站名称</div>
              <el-input
                type="text"
                class="inp"
                v-model="conditions.name"
                placeholder="请输入充电站名称"
                clearable
              />
            </div>
          </div>
          <div class="info-right">
            <button class="chaxun" @click="getMemberlist">查询</button>
            <button class="reset" @click="reset">重置</button>
          </div>
        </div>
      </div>
      <div class="cartabel">
        <el-table
          :data="memberlist.list"
          style="width: 100%; height: 85%"
          border
        >
          <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="name" label="充电站名称" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="locationName" label="充电站位置" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column prop="stationNum" label="充电桩个数" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column prop="stationNum" label="充电口个数" show-overflow-tooltip :render-header="renderHeader">
            <template v-slot="res">
              <div>
                {{ res.row.stationNum*2 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="enddate" label="负责人" show-overflow-tooltip :render-header="renderHeader"> </el-table-column>
          <el-table-column prop="storelong" label="负责人联系方式" show-overflow-tooltip :render-header="renderHeader">
          </el-table-column>
          <el-table-column label="对接日期" show-overflow-tooltip :render-header="renderHeader">
            <template v-slot="res">
              <span>{{ mydateFormat(res.row.gmtModified, '年月日') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span @click="jumpParticulars(res.row)" style="color: #13D168;cursor: pointer;"
                >查看详情</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="msgstatistics">
          <span style="margin-right: 20px">合计 充电站:{{ memberlist.total }}个</span>
          <span style="margin-right: 20px">充电桩个数:{{memberHj?memberHj.stationNum:0 }}个</span>
          <span style="margin-right: 20px">充电口个数:{{ memberHj? memberHj.stationNum*2:0 }}个</span>
        </div>
        <div class="paginations">
          <el-pagination
            :page-size="conditions.limit"
            layout="total,prev, pager,next, jumper"
            :total="memberlist.total"
            :current-page="memberlist.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle';
export default {
  components: {
    mTitle,
  },
  data() {
    return {
      listitem: [{ name: '充电站列表' }],
      plate: '', //车牌号
      addstatus: '', //充电状态
      datevalue: '', //开始结束时间
      value: '',
      name: '',
      total: 20,
      conditions: {
        page: 1,
        limit: 20,
        order: '',
        params: null,
        sidx: '',
        station: '',
        name: '',
      },
      memberlist: [],
      memberHj:null
    };
  },
  created() {
    if(this.$route.query.station){
      this.conditions.name=this.$route.query.station
    }
    this.getMemberlist();
  },
  methods: {
    // 充电站列表
    async getMemberlist() {
      const { data } = await this.$http(
        'api1',
        '/api/replenish/station/stationlist',
        'get',
        {
          station: this.conditions.name,
          page: this.conditions.page,
          limit: this.conditions.limit,
        }
        // this.conditions,
      );
      if (data.code != 0) return console.log('');
      this.memberlist = data.data;
      this.total = data.data.total;
      this.memberHj=data.hj
    },
    // 重置
    reset() {
      this.conditions.name = '';
      this.getMemberlist();
    },
    // 分页
    handleCurrentChange(index) {
      if (this.memberlist.total < this.conditions.limit) return;
      this.conditions.page = index;
      this.getMemberlist();
    },
    // 跳转
    jumpParticulars(res) {
      window.sessionStorage.setItem('station', res.locationName);
      this.$router.push({ name: 'addstoredetail' });
    },
  },
};
</script>

<style lang="scss" scoped>
.caraddstorelist {
  height: 100%;

  .carlist-box {
    width: 100%;
    height:calc(100% - 50px) ;
    background: #f5f6fa;
    border-radius: 20px;
    overflow: auto;
    padding: 10px;
    box-sizing: border-box;

    .box-title {
      width: 100%;
      background-color: #fff;

      .carlist-box-title {
        width: 100%;
        padding: 20px 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .title-left {
          width: 12px;
          height: 26px;
          background: #17b6a1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .title-right {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2d3748;
        }
      }

      .carinfo {
        width: 100%;
        padding: 8px 34px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .info-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .carplate,
          .caraddinfo,
          .adddate {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-right: 39px;

            .name {
              font-size: 80%;
              font-family: PingFang SC;
              font-weight: bold;
              color: #333333;
              margin-right: 20px;
            }
            .name1 {
              font-size: 80%;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin: 0 4px;
            }

            .inp {
              width: 160px;
              height: 30px;
              border-radius: 4px;
              border: none;
              outline: none;
              box-sizing: border-box;
            }
          }
        }

        .info-right {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .chaxun{
            width: 80px;
            height: 30px;
            background: #17b6a1;
            border-radius: 8px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
          }

          .reset {
            width: 80px;
            height: 30px;
            background-color: #f5f6fa;
            border-radius: 8px;
            color: #17b6a1;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
            margin-left: 20px;
          }
        }
      }
    }

    .cartabel {
      padding-top: 10px;
      width: 100%;
      // height: 665px;
      height: calc(100% - 100px);
      background-color: #fff;
      box-sizing: border-box;
      .msgstatistics{
        margin-top: 10px;
        font-size: 80%;
        line-height: 35px;
        text-align: center;
        color: #fff;
        font-weight: bold;
        background: #17B6A1;
      }
      .paginations {
        margin-top: 15px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
